export const sellerHasAgentSettings = (stateSettings, isSeller) => {
    if (isSeller) {
        //Default settings
        let settings = {
            isAgentStepSkipped: false,   // if true skip has-agent step
            isAgentRequired: false, // if true make agent required
            isHslpRequired: false,  // if true make HSLP required
            isRequiredHslpIfNoAgent: true, // if true the seller who has agent is not required to buy HSLP, else HSLP is required
        };
        if (!!stateSettings) {
            if (stateSettings.register?.is_hslp_required) {
                settings.isHslpRequired = stateSettings.register.is_hslp_required === 1;
            }
            if (stateSettings.register?.is_agent_required) {
                settings.isAgentRequired = stateSettings.register.is_agent_required === 1;
            }
            if (stateSettings.register?.is_agent_step_skipped) {
                settings.isAgentStepSkipped = stateSettings.register.is_agent_step_skipped === 1;
            }
            if (stateSettings.register?.is_required_hslp_if_no_agent) {
                settings.isRequiredHslpIfNoAgent = stateSettings.register.is_required_hslp_if_no_agent === 1;
            }
        }
        return settings;
    }

}